import 'rxjs/add/operator/filter';

import nxModule from 'nxModule';

const templateUrl = require('./roles-list.template.html');

const baseUrl = '/admin/security/roles/';

// A command that is waiting for approval, an OTP or an external validation has not executed yet:
// the command service has already told the user so, and nothing on the list may change.
const isPending = response => Boolean(response.approvalRequired || response.otpRequired || response.validationRequired);

// The command service has already shown the error popup; the row is simply left as it was.
const keepRowOnError = () => undefined;

export class RolesListController {
  constructor($location, rolesCache, command, confirmation) {
    this.$location = $location;
    this.rolesCache = rolesCache;
    this.command = command;
    this.confirmation = confirmation;
  }

  openRole(index) {
    this.$location.path(baseUrl.concat(this.roles[index].id));
  }

  addRole() {
    this.roles.push({dirty: true});
  }

  cancelAddRole(index) {
    this.roles.splice(index, 1);
  }

  isSaveDisabled(index) {
    return !this.roles[index].name;
  }

  saveRole(index) {
    const role = this.roles[index];
    if (!role.name) {
      return Promise.resolve();
    }

    return this.confirmation('Do you want to save the role?').then(confirmed => {
      if (!confirmed) {
        return;
      }

      return this.command.execute('CreateRole', {
        name: role.name,
        technical: false,
        cashierCounter: Boolean(role.cashierCounter),
        agent: Boolean(role.agent),
        enabled: Boolean(role.enabled)
      }, {nxLoaderText: 'Saving role'}).toPromise().then(response => {
        if (isPending(response) || !response.output) {
          return;
        }

        this.rolesCache.evict();
        role.dirty = false;
        role.id = response.output.id;
      }, keepRowOnError);
    });
  }

  deleteRole(index) {
    const role = this.roles[index];

    return this.confirmation(`Do you want to remove role ${role.name}?`).then(confirmed => {
      if (!confirmed) {
        return;
      }

      return this.command.execute('DeleteRole', {id: role.id}, {nxLoaderText: 'Removing role'})
        .toPromise()
        .then(response => {
          if (isPending(response)) {
            return;
          }

          this.rolesCache.evict();
          const position = this.roles.indexOf(role);
          if (position >= 0) {
            this.roles.splice(position, 1);
          }
        }, keepRowOnError);
    });
  }

  editRole(index) {
    this.$location.path(baseUrl.concat(`edit/${this.roles[index].id}`));
  }
}

nxModule.component('rolesList', {
  templateUrl,
  bindings: {
    // List of roles
    'roles': '='
  },
  controller: RolesListController
});
